const DOWNLOAD_URL = "/api/remotion-claude-guide/download";

const DownloadSection: React.FC = () => {
  return (
    <section className="bg-black text-white py-16 px-4">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Why is it free?
        </h2>

        <p className="text-xl text-gray-300 mb-8 leading-relaxed">
          Because I want more builders creating great video content without expensive tools or agencies. This is the exact workflow I use — shared openly.
        </p>

        <div className="bg-gradient-to-r from-cyan-400/10 to-cyan-600/10 border-2 border-cyan-400 rounded-xl p-8 mb-8">
          <p className="text-5xl font-bold text-cyan-400 mb-2">Free</p>
          <p className="text-gray-400 text-xl mb-4">No payment. No email gate.</p>
          <p className="text-gray-300 mb-6">Click below and the PDF downloads instantly.</p>
        </div>

        <a
          href={DOWNLOAD_URL}
          className="inline-block bg-cyan-400 hover:bg-cyan-300 text-black hover:text-black font-bold py-4 px-12 rounded-lg text-xl transition-all transform hover:scale-105 shadow-lg shadow-cyan-400/50"
        >
          Download the Free PDF
        </a>

        <p className="text-sm text-gray-400 mt-4">
          Instant download. No upsells. No bullshit.
        </p>
      </div>
    </section>
  );
};

export default DownloadSection;
